import { SxProps, Theme } from '@mui/material/styles'
import { isEmpty } from 'lodash'

import CowmedChip from '#/components/Chip'
import Colors from '#/styles/Colors'

export type StatusChipStatus = 'failed' | 'success'

export type StatusChip = {
  status: StatusChipStatus
  text: string
}

interface TypeStatusChipProps {
  value: StatusChip
  sx?: SxProps<Theme>
}

const STATUS_STYLE: Record<StatusChipStatus, (typeof Colors.feedback)['success']> = {
  failed: Colors.feedback.error,
  success: Colors.feedback.success,
}

export function TypeStatusChip({ sx, value }: TypeStatusChipProps) {
  if (isEmpty(value)) return '-'

  const { status, text } = value

  return <CowmedChip value={text} width="unset" style={STATUS_STYLE[status]} sx={sx} />
}
